import { Divider } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import WindsorApi from '../../api/WindsorApi';
import LinkRouter from '../../common/LinkRouter';
import LoadingIndicator from '../../common/LoadingIndicator';
import MobxContext from '../../mobx/MobxContext';
import FaroParamSetForm from './FaroParamSetForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

const windsorApi = new WindsorApi();

function FaroParamSetEditPage(props: RouteComponentProps<any> & WithSnackbarProps) {
  const { match: { params: { accountId, region, name } }, history, enqueueSnackbar } = props;
  const classes = useStyles({});
  const [originalParamSet, setOriginalParamSet] = useState(null);
  const [paramSet, setParamSet] = useState(null);
  const { environmentStore } = useContext(MobxContext);

  useEffect(() => {
    windsorApi.getFaroParameterSet(name, 'latest', accountId, region).then(res => {
      setOriginalParamSet(res);
      setParamSet({
        name,
        accountId,
        region,
        parameters: res.Parameters
      });
    });
  }, [name, accountId, region]);

  const onCancel = () => {
    history.push(`/faro/parameters/${accountId}/${region}/${originalParamSet.Name}`);
  };

  const onSave = () => {
    return windsorApi.createParameterSetVersion({
      Name: originalParamSet.Name,
      Parameters: paramSet.parameters
    }, accountId, region, originalParamSet.CreatedBy).then(res => {
      enqueueSnackbar(`Parameter set ${res.Name} updated`);
      return res;
    });
  };

  const onSaveComplete = () => {
    history.push(`/faro/parameters/${accountId}/${region}/${originalParamSet.Name}`);
  };

  const environment = paramSet && environmentStore.environments ? environmentStore.getEnvironmentByAccountId(paramSet.accountId) : null;

  return originalParamSet && environment ? (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="textSecondary" to={`/faro/parameters?environmentName=${environment.EnvironmentName}&region=${region}`}>
          Parameter Sets
        </LinkRouter>
        <LinkRouter color="textSecondary" to={`/faro/parameters/${accountId}/${region}/${originalParamSet.Name}`}>
          {originalParamSet.Name}
        </LinkRouter>
        <Typography color="textPrimary">edit</Typography>
      </Breadcrumbs>
      <Divider className={classes.divider} />
      <FaroParamSetForm
        paramSet={paramSet}
        assumeRoleArn={originalParamSet.CreatedBy}
        title="Edit Parameter Set"
        disableEditingDetails
        environments={environmentStore.environments}
        onParamSetChange={setParamSet}
        onSave={onSave}
        onSaveComplete={onSaveComplete}
        onCancel={onCancel}
       />
    </div>
  ) : <LoadingIndicator loading={true} />;
};

export default withRouter(withSnackbar(observer(FaroParamSetEditPage)));
